import React, {Component} from "react";
import ListOfVideosLists from "./ts/ListOfVideosLists";
import VideosDB from "../../client-data/ts/VideosDB";
import {thisIsMobile} from "../../client-data/GlobalConstants";
import VideosDisplayerComponent from "./VideosDisplayerComponent";
import VideoFullScreenModal from "./VideoFullScreenModal";
import Modal from "react-bootstrap/Modal";
import {VIDEO_DISPLAYER_LIST} from "../../client-data/clientOptions";
import VideoDisplayerComponent from "./VideoDisplayerComponent";

export default class VideosListFactoryComponent extends Component {

    videosData = null;
    videosMeshBtnObj = null;

    constructor(props) {
        super(props);
        // console.log("[VideosListFactoryComponent] is running")
        const videosListWithMeshButtonIDs = new ListOfVideosLists(VideosDB);
        if(videosListWithMeshButtonIDs) {
            this.videosMeshBtnObj = videosListWithMeshButtonIDs.getVideosListByMeshBtnId(this.props.meshBtnId);
            // console.log("[VideosListFactoryComponent]", this.videosMeshBtnObj);
            if(this.videosMeshBtnObj) {
                this.videosData = this.videosMeshBtnObj.videosList;
                // console.log("[VideosListFactoryComponent]", this.videosData);
            }

        }


        this.state = {
            showFlag: true,
            showVideoFullScreenModal: false,
            currentVideoData: null,
        }

        this.hideVideoDisplayModal = this.hideVideoDisplayModal.bind(this);
        this.onClickVideoThumbnail = this.onClickVideoThumbnail.bind(this);
        this.onHideVideoFullScreenModal = this.onHideVideoFullScreenModal.bind(this);
    }


    hideVideoDisplayModal = () => {
            this.setState({showFlag: false});

        this.props.hideVideoDisplayModal();
    }

    onClickVideoThumbnail = (videoDataObj) => {
        if (thisIsMobile) {
            console.log("[VideosListFactoryComponent] not mobile");
            this.setState({
                showFlag: false,
                showVideoFullScreenModal: true,
                currentVideoData: videoDataObj});
        } else {
            this.setState({
                showFlag: false,
                showVideoFullScreenModal: false,
                currentVideoData: null,
            })
        }

        this.props.onClickThumbnail(videoDataObj, this.props.meshBtnId);

    }

    onHideVideoFullScreenModal = () => {
        console.log("[VideosListFactoryComponent is closing!")
        this.setState({
            showFlag: false,
            showVideoFullScreenModal: false,
        })
        this.props.hideVideoFullScreen();
    }


    render() {

        console.log("[VideosListFactoryComponent] Render: ", this.videosData);

        const videoFullScreenComponent = <VideoFullScreenModal show={this.state.showVideoFullScreenModal}
                                                               onHideModal={this.onHideVideoFullScreenModal}
                                                               videoData={this.state.currentVideoData}
                                                               modelType="lg"
        />

        return (
            <div>
                {videoFullScreenComponent}
                <VideosDisplayerComponent show={this.state.showFlag}
                                          close={this.hideVideoDisplayModal}
                                          videosData={this.videosData}
                                          modelType="md"
                                          onClickThumbnail={this.onClickVideoThumbnail}/>
            </div>
        )

    }


}